import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../services/api';
import { toast } from '../utils/toast';
import './Auth.css';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const token = searchParams.get('token');

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Токен не предоставлен');
        return;
      }

      try {
        const response = await api.get('/auth/verify-email', { params: { token } });
        if (response.data && response.data.success) {
          setStatus('success');
          setMessage(response.data.message || 'Email успешно подтвержден!');
          toast.success('Email успешно подтвержден!');
          // Перенаправляем на страницу входа через 3 секунды
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(response.data.error || 'Ошибка при подтверждении email');
        }
      } catch (error) {
        console.error('Email verification error:', error);
        setStatus('error');
        setMessage(error.response?.data?.error || 'Ошибка при подтверждении email');
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>SAVEL'EV CRM</h1>
          <h2>Подтверждение email</h2>
        </div>
        <div className="auth-content">
          {status === 'verifying' && (
            <div className="verification-status">
              <div className="spinner"></div>
              <p>Подтверждение email...</p>
            </div>
          )}

          {status === 'success' && (
            <div className="verification-status success">
              <div className="success-icon">✅</div>
              <p>{message}</p>
              <p className="redirect-message">Перенаправление на страницу входа...</p>
              <Link to="/login" className="btn btn-primary">Перейти к входу</Link>
            </div>
          )}

          {status === 'error' && (
            <div className="verification-status error">
              <div className="error-icon">❌</div>
              <p>{message}</p>
              <div className="verification-actions">
                <Link to="/login" className="btn btn-primary">Войти</Link>
                <Link to="/register" className="btn btn-secondary">Зарегистрироваться</Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
